import { starPath } from "@/data/artHelpers";

const ITEMS = [
  "TRICK OR TREAT",
  "BOO!",
  "HAPPY HALLOWEEN",
  "SPOOKY SCRIBBLES",
  "MAGIC IN EVERY COLOR",
  "GLOW WITH THE FLOW",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-4xl ${i % 2 ? "text-slime text-glow-slime" : "text-pumpkin text-glow-orange"}`}
          >
            {t}
          </span>
          <svg viewBox="0 0 24 24" width="20" height="20" className="mx-6 shrink-0 text-lavender">
            <path d={starPath(12, 12, 10)} fill="currentColor" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-night/70 py-5"
    >
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
}
